import { Text } from 'common-components/typography';
import React from 'react';
import _ from 'lodash';
import { IRosterShift } from '../../types';
import { Calendar } from '@good/icons';
import { Avatar, Box } from '@good/ui/core';
import { rosterConfig } from '../../roster-config';

interface OpenShiftsContentRowProps {
  unassignedShifts?: IRosterShift[][];
}

const { TIMELINE_ROW_HEIGHT } = rosterConfig;

export function OpenShiftsSideColumn({ unassignedShifts = [] }: OpenShiftsContentRowProps) {
  const rowHeight = _.size(unassignedShifts) * TIMELINE_ROW_HEIGHT;
  const shiftsCount = _.chain(unassignedShifts).flatten().size().value();

  return (
    <Box
      className='roster-gray flex-row justify-between bordered-right bordered-bottom'
      style={{ height: rowHeight }}
      px='lg'
    >
      <div className='flex-row align-center'>
        <Avatar radius='md' mr='sm'>
          <Calendar />
        </Avatar>
        <div className='line-height-135 flex-column'>
          <Text lineHeight={120}>Unassigned shifts</Text>
          <div className='line-height-120 flex-row align-center'>
            <Text size='regular' color='secondary' lineHeight={120}>
              {shiftsCount} unassigned
            </Text>
          </div>
        </div>
      </div>
    </Box>
  );
}
